// src/components/AppLayout/views/ChatView.tsx
import React from "react";
import Chat from "../../Chat"; // Your original Chat component
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useAppSelector } from "../../../hooks/hooks"; // Adjust the import path as necessary
import NotificationCenter from "../../NotificationCenter";
import NotificationSystem from "../../NotificationSystem";
import ConnectionStatusIndicator from "../../ConnectionStatusIndicator";

const MOBILE_APP_WIDTH = parseInt(
  process.env.REACT_APP_MOBILE_APP_WIDTH || "500"
);

const ChatView: React.FC = () => {
  const { token } = useAppSelector((state) => state.auth);
  const isMobile = useMediaQuery(`(max-width:${MOBILE_APP_WIDTH}px)`);
  const { isCompletingLogin } = useAppSelector((state) => state.ui);
  return (
    <Box
      sx={{
        p: 2,
        height: "100%",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {token && !isCompletingLogin && (
        <>
          <Box sx={{ mb: 2, flexShrink: 0 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="h4" gutterBottom>
                  Chat Place
                </Typography>
                <ConnectionStatusIndicator />
              </Box>

              <NotificationCenter />
            </Box>

            <Typography variant="body1" gutterBottom>
              Engage in conversations with your friends and family.
            </Typography>
          </Box>
        </>
      )}
      <Box
        sx={{
          flex: 1, // Takes up remaining space
          position: "fixed",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          flexShrink: 0,
          width: isMobile ? "393px" : "466px",
        }}
      >
        <Chat />
      </Box>

      <NotificationSystem />
    </Box>
  );
};

export default ChatView;
